<div class="footer">
  <div class="container-fluid">
    <div class="container mx-auto">
      <div class="grid grid-cols-12 !gap-0 px-0">
        <div class="col-span-12 tablet:col-span-6 pr-0">
          <ul class="whitespace-nowrap">
            <li>
              <a
                yat-link
                class="link text-secondary"
                [yatExternalLink]="TERMS_OF_SERVICE_URL$ | async"
                [matomoClickCategory]="MATOMO_EVENT_CATEGORY_FOOTER"
                matomoClickAction="Select_ExternalYattaLink"
                matomoClickName="Terms"
                >{{ 'terms' | legalWording: staticKeys | async }}</a
              >
            </li>
            <li>
              <a
                yat-link
                class="link text-secondary"
                [yatExternalLink]="PRIVACY_POLICY_URL$ | async"
                [matomoClickCategory]="MATOMO_EVENT_CATEGORY_FOOTER"
                matomoClickAction="Select_ExternalYattaLink"
                matomoClickName="Privacy"
                >{{ 'privacy' | legalWording: staticKeys | async }}</a
              >
            </li>
            <li>
              <a
                yat-link
                class="link text-secondary"
                [yatExternalLink]="IMPRINT_URL"
                [matomoClickCategory]="MATOMO_EVENT_CATEGORY_FOOTER"
                matomoClickAction="Select_ExternalYattaLink"
                matomoClickName="LegalNotice"
                >{{ 'legalNotice' | legalWording: staticKeys | async }}</a
              >
            </li>
          </ul>
        </div>
        <div class="col-span-12 tablet:col-span-6 text-d-right">
          <p>{{ 'poweredBy' | legalWording: staticKeys | async }}</p>
          <a yatExternalLink="https://yatta.de" [matomoClickCategory]="MATOMO_EVENT_CATEGORY_LINKS" matomoClickAction="FooterLink" matomoClickName="YattaLogo">
            <yat-icon id="d3e0406b-3fb3-43a3-91c6-8fdbf5675312" name="yatta-logo" class="yatta-logo" [multiColored]="true"></yat-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
